import { createTypes } from '../../utils/helpers';

const SUPPLIERS_FETCH_SUPPLIERS: any = createTypes('SUPPLIERS_FETCH_SUPPLIERS');
export { SUPPLIERS_FETCH_SUPPLIERS };
